// Pure, side-effect-free helpers for the "Agendar liberação do conteúdo"
// (content release scheduling) section of the EditVideo admin screen.
//
// The logic lived inline inside the component (convertDaysSchedulingDays, the
// unit pluralization in the <Picker>, and the plan-chip removal). Extracting it
// here keeps a single source of truth that is trivially unit-testable without
// pulling in React Native / Firebase / Expo.

// Converts a quantity + unit into the number of days used by the scheduling
// engine. Mirrors the original inline behavior exactly:
//   dia   -> n
//   semana-> n * 7
//   mês/mes-> n * 30
//   (anything else) -> 0
export function daysFromUnit(number, unit) {
  if (unit === 'semana') return number * 7;
  if (unit === 'mês' || unit === 'mes') return number * 30;
  if (unit === 'dia') return number;
  return 0;
}

// Steps the day-count up or down, clamped so it never goes below `min` (0 by
// default). This prevents the stepper from ever producing a negative count — the
// old inline decrement called the conversion with `selectedNumber - 1` even at 0,
// which persisted a negative `schedulingDays`.
export function stepCount(current, delta, min = 0) {
  return Math.max(min, current + delta);
}

// Label shown in the unit <Picker>. Pluralizes only when count > 1, and only for
// the three known units; unknown units are returned unchanged.
export function pluralizeUnit(unit, count) {
  if (count > 1) {
    if (unit === 'dia') return 'dias';
    if (unit === 'semana') return 'semanas';
    if (unit === 'mês') return 'meses';
  }
  return unit;
}

// Removes a plan from the selected-plans list when the user taps the chip's "x".
// Uses reference equality to match the original `filter((item) => item !== plan)`
// so identical-looking plans elsewhere in the list are never removed by accident.
// Always returns a new array (never mutates the input) and tolerates null/undefined.
export function removeSelectedPlan(selectedPlans, planToRemove) {
  return (selectedPlans || []).filter((item) => item !== planToRemove);
}
